// (c) Copyright Ascensio System SIA 2009-2025
//
// This program is a free software product.
// You can redistribute it and/or modify it under the terms
// of the GNU Affero General Public License (AGPL) version 3 as published by the Free Software
// Foundation. In accordance with Section 7(a) of the GNU AGPL its Section 15 shall be amended
// to the effect that Ascensio System SIA expressly excludes the warranty of non-infringement of
// any third-party rights.
//
// This program is distributed WITHOUT ANY WARRANTY, without even the implied warranty
// of MERCHANTABILITY or FITNESS FOR A PARTICULAR  PURPOSE. For details, see
// the GNU AGPL at: http://www.gnu.org/licenses/agpl-3.0.html
//
// You can contact Ascensio System SIA at Lubanas st. 125a-25, Riga, Latvia, EU, LV-1021.
//
// The  interactive user interfaces in modified source and object code versions of the Program must
// display Appropriate Legal Notices, as required under Section 5 of the GNU AGPL version 3.
//
// Pursuant to Section 7(b) of the License you must retain the original Product logo when
// distributing the program. Pursuant to Section 7(e) we decline to grant you any rights under
// trademark law for use of our trademarks.
//
// All the Product's GUI elements, including illustrations and icon sets, as well as technical writing
// content are licensed under the terms of the Creative Commons Attribution-ShareAlike 4.0
// International. See the License terms at http://creativecommons.org/licenses/by-sa/4.0/legalcode

import difference from "lodash/difference";

import { LANGUAGE } from "../constants";

import { getCookie } from "./cookie";

export function getLanguage(lng: string) {
  try {
    if (!lng) return lng;

    let language = lng === "en-US" || lng === "en-GB" ? "en" : lng;

    const splitted = lng.split("-");

    if (splitted.length === 2 && splitted[0] === splitted[1].toLowerCase()) {
      [language] = splitted;
    }

    return language;
  } catch {
    return lng;
  }
}

export const getBannerAttribute = () => {
  const bar = document.getElementById("bar-banner");
  const mainBar = document.getElementById("main-bar");
  const rects = mainBar ? mainBar.getBoundingClientRect() : null;

  const headerHeight = bar
    ? 108 + 50
    : mainBar && rects?.height
      ? rects.height + 40
      : 48 + 50;

  const sectionHeaderTop = bar
    ? "108px"
    : rects
      ? `${rects.height + 40}px`
      : "48px";

  const sectionHeaderMarginTop = bar
    ? "106px"
    : rects
      ? `${rects.height + 36}px`
      : "46px";

  const loadLanguagePath = async () => {
    if (!window?.firebaseHelper) return;

    const lng: string[] | string = getCookie(LANGUAGE) || "en";

    const language = getLanguage(typeof lng === "object" ? lng[0] : lng);

    const localBar = (localStorage.getItem("bar") || "")
      .split(",")
      .filter((b) => b.length > 0);

    const localItem = localStorage.getItem("barClose");

    const closed = localItem ? JSON.parse(localItem) : [];

    const banner = difference(localBar, closed);

    let index = Number(localStorage.getItem("barIndex") || 0);
    if (index >= banner.length) {
      index -= 1;
    }
    const currentBar = banner[index];

    let htmlUrl =
      currentBar && window.firebaseHelper?.config?.authDomain
        ? `https://${window.firebaseHelper.config.authDomain}/${language}/${currentBar}/index.html`
        : null;

    if (htmlUrl) {
      await fetch(htmlUrl).then((data) => {
        if (data.ok) return;
        htmlUrl = null;
      });
    }

    return [htmlUrl, currentBar];
  };

  return {
    headerHeight,
    sectionHeaderTop,
    sectionHeaderMarginTop,
    loadLanguagePath,
  };
};
